/** @module Specification/DataPackageGenerate */
define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/locale",
	"csi/widget/MessageDialog",
	"SiteAdmin/GeneratePDF"
], function(declare,csi,_,locale,MessageDialog,GeneratePDF) {

	return declare(GeneratePDF, {

		/**
		 * @override
		 *
		 * Display a confirmation dialog when one of the Data Sheets has ForProductSource attribute different from Data Package's ForProductSource attribute
		 */
		hasToConfirmAction: function() {
			var cache = this.getCache();
			var dataPackage = this.getNode();
			if (!dataPackage.ForProductSource || dataPackage.ForProductSource == csi.EMPTY_URL) {
				this.refreshDataSheets = false;
				this.confirmForProductSource = false;
				return this.confirmForProductSource;
			}

			this.confirmForProductSource = _.some(dataPackage.DataSheets, function(dataPackageSheetURL) {
				var dataPackageSheet = cache.getNode(dataPackageSheetURL);
				if (!dataPackageSheet)
					return false;
				var dataSheetRevision = cache.getNode(dataPackageSheet.Sheet);
				if (!dataSheetRevision)
					return false;
				var dataSheet = cache.getNode(dataSheetRevision.__Parent__);
				if (!dataSheet)
					return false;
				return (dataSheet.ForProductSource && dataSheet.ForProductSource != csi.EMPTY_URL && dataSheet.ForProductSource != dataPackage.ForProductSource)
			});

			this.refreshDataSheets = this.confirmForProductSource;
			return this.confirmForProductSource;
		},

		/**
		 * @override
		 *
		 * GenerateDataPackage has 2 confirmation dialogs: RefreshDataSheets_Confirm and GeneratePDF_Confirm
		 * this.forProductSourceConfirmed indicates that the RefreshDataSheets_Confirm dialog has already appeared
		 */
		confirmAction: function(params) {
			if (this.confirmForProductSource) {
				params = params || {};
				params.title = this.m_action.m_name;
				params.message = locale.typeAction("DataPackage", "RefreshDataSheets_Confirm");
				params.buttons = [MessageDialog.BUTTON_OK, MessageDialog.BUTTON_CANCEL];
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 *
		 * GenerateDataPackage has 2 confirmation dialogs: RefreshDataSheets_Confirm and GeneratePDF_Confirm
		 * confirmForProductSource indicates that the RefreshDataSheets_Confirm dialog needs to appear
		 */
		onConfirm: function(key) {
			if (key == MessageDialog.BUTTON_OK && this.confirmForProductSource) {
				this.confirmForProductSource = false;
				this.preProcess();
			}

			this.inherited(arguments);
		},

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: initialize fields from user settings
			view.addDefaultValue("RefreshDataSheets", true);
			this.inherited(arguments);
		},

		postProcessSuccess: function() {
			// refresh data sheets view if necessary
			if (this.refreshDataSheets || this.m_formData.getFieldValue("RefreshDataSheets")) {
				var	view = this.widget.viewParent.getChildView("DataSheets");
				if (view) {
					this.widget.refreshData();
				}
			}
			this.inherited(arguments);
		}
	});
});